export default __webpack_public_path__ + "static/media/googlemaps.d9de55dd.svg";